import React from "react";

import { connect } from "react-redux";
import * as actions from "actions";

import { Link, NavLink, withRouter } from "react-router-dom";
import { heroStyles } from "./styles";
import { LogoAvatar } from "../LogoAvatar";
import { Button } from "../Button";
import { FluidSection } from "../FluidSection/index";
import { Content } from "../Content/index";
import { constants } from "../../constants/index";
import cloneDeep from "lodash/cloneDeep";

/*

Props:

• style
• height
• backgroundImageURL
• avatarImageURL
• avatarLogoURL

• mainTitleText
• subTitleText

• buttonIconName
• buttonText
• buttonIconSize
• buttonBackgroundColor
• buttonLinkURL

*/

const _applyStyleModifiers = props => {
  const clonedStyles = cloneDeep(heroStyles);
  const componentStyles = clonedStyles;

  componentStyles.imageOverlay = props.tintOpacity
    ? {
        ...componentStyles.imageOverlay,
        backgroundColor: `rgba(0,0,0,${props.tintOpacity})`
      }
    : {
        ...componentStyles.imageOverlay,
        backgroundColor: "rgba(0,0,0,0.4)"
      };
  componentStyles.titleContainer =
    props.orientation === "row"
      ? {
          ...componentStyles.titleContainer,
          justifyContent: "flex-start",
          alignItems: "flex-start",
          marginLeft: 50
        }
      : {
          ...componentStyles.titleContainer,
          justifyContent: "center",
          alignItems: "center",
          marginLeft: 0
        };

  componentStyles.titleContainer =
    props.orientation === "column"
      ? {
          ...componentStyles.titleContainer,
          justifyContent: "center",
          alignItems: "center",
          marginLeft: 0
        }
      : {
          ...componentStyles.titleContainer
        };

  componentStyles.contentContainerStyle =
    props.orientation === "row"
      ? {
          ...componentStyles.contentContainerStyle,
          flexDirection: "row-reverse",
          justifyContent: "center",
          maxWidth: 1200,
          margin: "0 5%"
        }
      : {
          ...componentStyles.contentContainerStyle
        };

  componentStyles.contentContainerStyle =
    props.orientation === "column"
      ? {
          ...componentStyles.contentContainerStyle,
          flexDirection: "column",
          justifyContent: "center", // if mainTitleText and subTitleText are '' then
          maxWidth: "100vw",
          margin: "0 5%"
        }
      : {
          ...componentStyles.contentContainerStyle
        };

  componentStyles.mainTitleStyle = props.titleColor
    ? {
        ...componentStyles.mainTitleStyle,
        color: props.titleColor
      }
    : {
        ...componentStyles.mainTitleStyle
      };
  componentStyles.subTitleStyle = props.titleColor
    ? {
        ...componentStyles.subTitleStyle,
        color: props.titleColor
      }
    : {
        ...componentStyles.subTitleStyle
      };

  componentStyles.contentContainerStyle =
    props.flexPosition === "flex-end"
      ? {
          ...componentStyles.contentContainerStyle,
          // ...constants.layout.contentWidth,
          // maxWidth: constants.layout.contentWidth.maxWidth - 20, /* -20px override to allow for card margins */
          // flexDirection: 'start',
          // width: '100%',
          // alignContent: 'flex-end',
          justifyContent: "flex-start",
          alignItems: "flex-end"
          // paddingRight: constats.paddingRight;
        }
      : {
          ...componentStyles.contentContainerStyle
        };
  componentStyles.imageOverlay =
    props.flexPosition === "flex-end"
      ? {
          ...componentStyles.imageOverlay,
          ...constants.layout.contentWidth,
          maxWidth:
            constants.layout.contentWidth.maxWidth -
            20 /* -20px override to allow for card margins */,
          // flexDirection: 'start',
          width: "100%",
          // alignContent: 'flex-end',
          justifyContent: "flex-start",
          alignItems: "flex-start"
          // paddingRight: constats.paddingRight;
        }
      : {
          ...componentStyles.imageOverlay
        };

  componentStyles.backgroundImageStyle = props.backgroundImageURL
    ? // Clone existing style object and add new props to the clone
      {
        ...componentStyles.backgroundImageStyle,
        backgroundImage: `url(${props.backgroundImageURL})`
      }
    : componentStyles.backgroundImageStyle.backgroundImage;

  componentStyles.backgroundImageStyle = props.height
    ? // Creates a new style object & applies the existing and new props to it
      { ...componentStyles.backgroundImageStyle, minHeight: props.height }
    : componentStyles.backgroundImageStyle.minHeight;

  return { ...componentStyles };
};
class HeroComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: "0",
      height: "0"
    };
  }
  componentWillMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    // this.setState(this.getNRandomNumbers(0, props.experts.length-1, 3)
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  handleAvatarClick = event => {
    if (
      this.props.selectedService &&
      this.props.selectedService.provider &&
      this.props.avatarClick
    ) {
      this.props.history.push(`/expert/${this.props.selectedService.provider}`);
      this.props.updateLocation(
        `/expert/${this.props.selectedService.provider}`
      );
    }
  };

  render() {
    const styles = { ...heroStyles, ..._applyStyleModifiers(this.props) };

    const handleClick = () => {
      location.href = `${this.props.buttonLinkURL}`;
    };

    const childNum = React.Children.count(this.props.children);

    return (
      <div className="backgroundImageStyle" style={styles.backgroundImageStyle}>
        <div className="imageOverlay" style={styles.imageOverlay}>
          <div
            className="contentContainer"
            style={{
              ...styles.contentContainerStyle,
              justifyContent:
                !this.props.mainTitleText &&
                !this.props.subTitleText &&
                !this.props.center
                  ? "flex-start"
                  : "center",
              ...this.props.style
            }}
          >
            <div className="titleContainer" style={styles.titleContainer}>
              {this.props.mainTitleText && (
                <h1
                  className="mainTitleStyle"
                  style={{
                    ...styles.mainTitleStyle,
                    textAlign: this.state.width < 800 ? "center" : "left"
                  }}
                >
                  {this.props.mainTitleText || "I'm a main title"}
                </h1>
              )}
              {this.props.subTitleText && (
                <h2 style={styles.subTitleStyle}>
                  {this.props.subTitleText || "I'm a subtitle"}
                </h2>
              )}
            </div>
            <div>
              {childNum > 0 &&
                React.Children.map(this.props.children, (child, i) => {
                  return <div>{child}</div>;
                })}
              {this.props.avatarImageURL && (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={this.handleAvatarClick}
                >
                  <LogoAvatar
                    imageURL={this.props.avatarImageURL}
                    logoURL={this.props.avatarLogoURL}
                    // size={220}
                    size={
                      this.props.logoAvatarSize
                        ? this.props.logoAvatarSize
                        : 220
                    }
                  />
                </div>
              )}
            </div>

            <div>
              {(this.props.buttonText || this.props.buttonIconName) && (
                <Button
                  play={this.props.playButton ? true : false}
                  onClick={() => this.props.buttonAction()}
                  iconName={this.props.buttonIconName}
                  style={styles.buttonStyle}
                  iconSize={this.props.buttonIconSize}
                  backgroundColor={this.props.buttonBackgroundColor}
                >
                  {this.props.buttonText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ service }) => {
  return {
    selectedService: service.selectedService
  };
};

export const Hero = withRouter(
  connect(
    mapStateToProps,
    actions
  )(HeroComponent)
);



// WEBPACK FOOTER //
// ./src/js/components/Hero/Hero.jsx